import React from 'react';

import CloseIcon from '@material-ui/icons/Close';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@material-ui/core';

import ForwarderHeaderInvoiceBalanceContainer from '../../forwarderHeaderInvoiceBalance/ForwarderHeaderInvoiceBalanceContainer';

import GhaModel from '../../../models/Gha';

import style from './ghaInfo.module.css';

interface GhaInfoModalProps { 
  gha: GhaModel;
  modalOpen: boolean;
  handleClose: () => void;
  type: 'import'| 'export';
};

const ghaInfoModal = (props: GhaInfoModalProps) => {

  const payPerHawbTariff: { cost_per_hawb_usd: number; } = props.gha.tariff.per_hawb || props.gha.tariff.per_hawb_exclude_import_service;

  return (
    <Dialog
      open={ props.modalOpen }
      onClose={ props.handleClose }
      aria-labelledby="form-dialog-title"
      maxWidth={ 'lg' }
    >
      <DialogTitle id="form-dialog-title" >
      <div className={ style.dialogTitle }>
        <span className={ style.nameModal }>{ props.gha.info.name }</span>
  
        { props.type === 'import' && 
          <ForwarderHeaderInvoiceBalanceContainer cssClassName={ style.invoiceBallanceTextGha } />
        }
        
        <IconButton aria-label="Close" className={ style.close } onClick={ props.handleClose }>
          <CloseIcon color='primary' />
        </IconButton>
      </div>
      <hr />
      </DialogTitle>
      <DialogContent className={ style.dialogContent }>
        <div className={ style.contentMiddle }>
        <div>{ props.gha.info.address }</div>
        <div>{ props.gha.info.tel }</div>
        </div>
        <div className={ style.contentSmall }>
          <div>Handled Carriers</div>
          <div>{  props.gha.airlines ? props.gha.airlines.join(', ') : '' }</div>
        </div>
        <div className={ style.contentLarge }>
          <div>Fee Schedule</div>
          <div>Storage Charges 48Hrs Fee, ${ props.gha.tariff.storage_fee.cost_per_storage_unit_per_day_usd }/{ props.gha.tariff.storage_fee.storage_divisor }KG </div>
          <div>Import Fee MAWB: ${ props.gha.tariff.import_service.cost_usd }</div>
          <div>Import Fee HAWB: ${ payPerHawbTariff.cost_per_hawb_usd }</div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default ghaInfoModal;
